function tableUpdates(container, CLASS_NAME) {
  const values = Array.from(container.querySelectorAll(`.${CLASS_NAME}__value--js`))

  function update(type) {
    values.forEach((value) => {
      if (value.dataset[type]) {
        const span = value.querySelector("span")
        span.textContent = value.dataset[type]
      }
    })
  }

  return update
}

function initTableUpdates(container, CLASS_NAME) {
  const currentValue = container.querySelector(`.${CLASS_NAME}__current-value--js`)

  const controls = Array.from(container.querySelectorAll(`.${CLASS_NAME}__dropdown-control--js`))

  const update = tableUpdates(container, CLASS_NAME)

  controls.forEach((control) => {
    control.addEventListener("click", () => {
      currentValue.textContent = control.textContent
      update(control.dataset.type)
    })
  })
}

export default initTableUpdates
